export default __webpack_public_path__ + "cb2e1eb99ea405ffd497f9522577e5e5.svg";